import { render } from "./ErrorPage.vue?vue&type=template&id=cb4aa7ee&scoped=true"
const script = {}

import "./ErrorPage.vue?vue&type=style&index=0&id=cb4aa7ee&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4aa7ee"]])

export default __exports__